import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

const footerLinks = {
  Company: [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/services' },
    { label: 'Contact', to: '/contact' },
  ],
  Services: [
    { label: 'Web Development', to: '/services' },
    { label: 'Mobile Apps', to: '/services' },
    { label: 'Cloud & DevOps', to: '/services' },
    { label: 'Software Architecture', to: '/services' },
  ],
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#050810] border-t border-[#1A2740]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src={logo}
                alt="Devstander"
                className="h-7 w-auto object-contain"
              />
              <span className="font-display font-bold text-lg text-white tracking-tight">
                Devstander
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              High-standard software development. We build reliable, scalable solutions
              that drive long-term business growth.
            </p>
            <div className="mt-6 flex flex-col gap-2">
              <a
                href="mailto:info@devstander.com"
                className="text-slate-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer flex items-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-[#3B82F6]"></i>
                </span>
                info@devstander.com
              </a>
              <a
                href="tel:+48532004860"
                className="text-slate-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer flex items-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-[#3B82F6]"></i>
                </span>
                +48 532 004 860
              </a>
              <span className="text-slate-400 text-sm flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-[#3B82F6]"></i>
                </span>
                Warsaw, Poland
              </span>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
                {category}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-slate-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                      rel={link.to.startsWith('http') ? 'nofollow' : undefined}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[#1A2740] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {year} Devstander. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            High-standard software development.
          </p>
        </div>
      </div>
    </footer>
  );
}
